module.exports = __webpack_public_path__ + "static/Banner_web-7bf3338649447df6fbb748faae605c92.jpg";